import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import * as HttpStatus from 'http-status-codes';

import { MainService } from '../../services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-offer-booking-fisiq',
  templateUrl: './offer-booking-fisiq.component.html',
  styleUrls: ['./offer-booking-fisiq.component.scss'],
})
export class OfferBookingFisiqComponent implements OnInit {
  option = undefined;
  service = undefined;
  clinics = undefined;
  currentBooking: any;
  currentClinic = '';
  selectedClinic: any;
  clinicServices: any;
  bodyParts = [];
  bookings = false;
  superClinicId: string;
  type: string;
  singleClinic: string;
  active_step: string;
  case: string;
  biURL: string;
  biAPI = this.helper.getBiApi();
  API = this.helper.getApi();
  loading = false;
  noTherapists = false;
  currentUser: any = this.helper.getStorage('currentUser');
  allClinics: Array<any> = this.helper.getStorage('allClinics');
  allBookings: Array<any> = this.helper.getStorage('bookings');
  readonly bodyPartLabels: any = Constants.BODY_PARTS_LABELS;
  readonly flowName: any = Constants.FLOW_TYPE;
  readonly clinicType = Constants.CLINIC_TYPE;
  readonly steps = Constants.STEPS;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public mainService: MainService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.superClinicId = params.superClinicId;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
      this.clinics = params.clinics;

      this.selectedClinic = this.allClinics.filter(
        (clinic) => this.clinics && clinic.id === this.clinics.toString()
      );

      this.clinicServices =
        this.selectedClinic && this.selectedClinic[0]
          ? this.selectedClinic[0]['services']
          : [];

      this.clinicServices.includes('');

      this.clinicServices = this.clinicServices.filter(
        (service) => service.visible === 1 && service.fysio === 1
      );
      this.clinicServices = _.sortBy(this.clinicServices, 'order');
    });

    if (this.superClinicId || this.singleClinic === 'true') {
      this.active_step = this.steps.offer;
    } else {
      this.active_step = this.steps.map;
    }

    this.biURL = this.biAPI.split('/api')[0];
  }

  bookNew(service) {
    const params = {
      type: this.type,
      service: service,
      singleClinic: this.singleClinic,
      clinics: this.clinics,
    };

    this.loading = true;

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    const selected_clinic = this.allClinics.filter(
      (clinic) => this.clinics && clinic.id === this.clinics.toString()
    );

    if (selected_clinic) {
      let selected_service: any = [];

      if (selected_clinic && selected_clinic[0]) {
        selected_service = selected_clinic[0].services.find(
          (el) => el.group_code === service
        );
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      if (selected_service.bodyParts === 0) {
        params['noBodyParts'] = true;
      } else {
        params['noBodyParts'] = false;
      }

      this.mainService
        .getTherapists(this.clinics.toString(), this.clinicType.single)
        .subscribe((therapistsResponse) => {
          this.handleTherapistsSuccess(
            therapistsResponse,
            selected_service,
            navigationExtras,
            params
          );
        });
    }
  }

  handleTherapistsSuccess(
    therapistsResponse,
    selectedService,
    navigationExtras,
    params
  ) {
    if (therapistsResponse.status === HttpStatus.OK) {
      const active_therapists = therapistsResponse.response.filter(
        ({ services }) =>
          services.some(
            ({ treatment_type_id }) => treatment_type_id === this.service
          )
      );

      if (active_therapists.length > 0) {
        // store all clinic therapists in localStorage on each expert step load
        localStorage.removeItem('allClinicTherapists');
        localStorage.setItem(
          'allClinicTherapists',
          JSON.stringify(active_therapists)
        );

        this.checkBodyParts(
          selectedService,
          navigationExtras,
          active_therapists,
          params
        );

        this.loading = false;
      } else {
        this.noTherapists = true;
        this.loading = false;
      }
    } else {
      this.noTherapists = true;
      this.loading = false;
    }
  }

  checkBodyParts(selectedService, navigationExtras, active_therapists, params) {
    if (selectedService.bodyParts === 0) {
      // if no expert therapists, go to service step
      this.checkIsExpert(
        selectedService,
        navigationExtras,
        active_therapists,
        params
      );
    } else {
      this.router.navigate(['/body-parts'], navigationExtras);
    }
  }

  checkIsExpert(selectedService, navigationExtras, active_therapists, params) {
    if (
      selectedService.is_expert === 1 ||
      this.type === this.flowName.aalborg
    ) {
      this.router.navigate(['/expert'], navigationExtras);
    } else {
      let physiotherapists = active_therapists.map((el) => el.id);

      localStorage.setItem(
        'clinicTherapists',
        JSON.stringify(physiotherapists)
      );

      params['noExperts'] = true;
      params['preselected_therapist'] = false;
      params['isExpert'] = false;
      params['bookings'] = this.allBookings ? this.allBookings.length : 0;

      this.router.navigate(['/service'], navigationExtras);
    }
  }

  goBack() {
    const params = {
      type: this.type,
      superClinicId: this.superClinicId,
      singleClinic: this.singleClinic,
    };

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/find-clinic'], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/offer-booking-fisiq/offer-booking-fisiq.component.ts